import store from "@/state/store";

export default [
  //login
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
          next();
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  //forgot password
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the forgot password page
          next();
        }
      },
    },
  },
  //reset password
  {
    path: "/reset-password",
    name: "Reset password",
    component: () => import("../views/account/create-password.vue"),
    meta: {
      title: "Reset Account Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the forgot password page
          next();
        }
      }
    },
  },
  //logout
  {
    path: "/logout",
    name: "logout",
    component: () => import("../views/account/logout.vue"),
    meta: {
      title: "Logout",
      beforeResolve(routeTo, routeFrom, next) {

        localStorage.removeItem("user");
        localStorage.removeItem("userid");
        localStorage.removeItem("jwt");

        next();
      },
    },
  },
  //default dashboard
  {
    path: "/",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    component: () => import("../views/dashboard/default/index.vue"),
  },
  //client management - client
  {
    path: "/client",
    name: "client",
    meta: {
      title: "Client",
      authRequired: true,
    },
    component: () => import("../views/client/client.vue"),
  },
  //client management - site
  {
    path: "/client/site",
    name: "Site",
    meta: {
      title: "Site",
      authRequired: true,
    },
    component: () => import("../views/client/site.vue"),
  },
  //client management - site qr viewer
  {
    path: "/client/site-qr-viewer",
    name: "Site QR Code Viewer",
    meta: {
      title: "Site QR Code Viewer",
      authRequired: true,
    },
    component: () => import("../views/client/site-qr-viewer.vue"),
  },
  //client management - block
  {
    path: "/client/block",
    name: "Block",
    meta: {
      title: "Block",
      authRequired: true,
    },
    component: () => import("../views/client/block.vue"),
  },
  //client management - area
  {
    path: "/client/area",
    name: "Area",
    meta: {
      title: "Area",
      authRequired: true,
    },
    component: () => import("../views/client/area.vue"),
  },
  //client management - location
  {
    path: "/client/location",
    name: "Location",
    meta: {
      title: "Location",
      authRequired: true,
    },
    component: () => import("../views/client/location.vue"),
  },
  //client management - location qr viewer
  {
    path: "/client/location-qr-viewer",
    name: "Room QR Code Viewer",
    meta: {
      title: "Room QR Code Viewer",
      authRequired: true,
    },
    component: () => import("../views/client/location-qr-viewer.vue"),
  },
  //client management - location import & preview
  {
    path: "/client/location-import",
    name: "Room Import & Preview",
    meta: {
      title: "Room Import & Preview",
      authRequired: true,
    },
    component: () => import("../views/client/location-import.vue"),
  },
  //user management - role
  {
    path: "/user/role",
    name: "Role",
    meta: {
      title: "Role",
      authRequired: true,
    },
    component: () => import("../views/user/role.vue"),
  },
  //user management - team
  {
    path: "/user/team",
    name: "Team",
    meta: {
      title: "Team",
      authRequired: true,
    },
    component: () => import("../views/user/team.vue"),
  },
  //user management - department
  {
    path: "/user/department",
    name: "Department",
    meta: {
      title: "Department",
      authRequired: true,
    },
    component: () => import("../views/user/department.vue"),
  },
  //user management - user
  {
    path: "/user/employee",
    name: "User",
    meta: {
      title: "User",
      authRequired: true,
    },
    component: () => import("../views/user/employee.vue"),
  },
  //FM Inspection Report
  {
    path: "/qa/fm-checklist",
    name: "FM Inspection Report [Weekly]",
    meta: {
      title: "FM Inspection Report [Weekly]",
      authRequired: true,
    },
    component: () => import("../views/qa-fm-checklist/checklist-grid-view.vue"),
  },
  //FM Inspection Reports
  {
    path: "/qa/reports",
    name: "FM Inspection Reports [Weekly]",
    meta: {
      title: "FM Inspection Reports [Weekly]",
      authRequired: true,
    },
    component: () => import("../views/qa-fm-checklist/qa-reports.vue"),
  },
  //FM Inspection Report Viewer
  {
    path: "/qa/report-viewer",
    name: "FM Inspection Report Viewer",
    meta: {
      title: "FM Inspection Report Viewer",
    },
    component: () => import("../views/qa-fm-checklist/qa-report-viewer.vue"),
  },
  //Service Performances Report
  {
    path: "/qa/sp-report",
    name: "Service Performances Report [Monthly]",
    meta: {
      title: "Service Performances Report [Monthly]",
      authRequired: true,
    },
    component: () => import("../views/qa-fm-checklist/sp-report.vue"),
  },
  //Service Performances Reports
  {
    path: "/qa/sp-reports",
    name: "Service Performances Reports [Monthly]",
    meta: {
      title: "Service Performances Reports [Monthly]",
      authRequired: true,
    },
    component: () => import("../views/qa-fm-checklist/sp-reports.vue"),
  },
    //Service Performances Report Viewer
    {
    path: "/qa/sp-report-viewer",
    name: "Service Performances Report Viewer",
    meta: {
      title: "Service Performances Report Viewer",
    },
    component: () => import("../views/qa-fm-checklist/sp-report-viewer.vue"),
  },
  //QA Overall Reports
  {
    path: "/qa/overall-reports",
    name: "QA Overall Reports",
    meta: {
      title: "QA Overall Reports",
      authRequired: true,
    },
    component: () => import("../views/qa-fm-checklist/overall-reports.vue"),
  },
  //QA Overall Report Viewer
  {
    path: "/qa/overall-report-viewer",
    name: "QA Overall Report Viewer",
    meta: {
      title: "QA Overall Report Viewer",
    },
    component: () => import("../views/qa-fm-checklist/overall-report-viewer.vue"),
  },
  {
    path: "/coming-soon",
    name: "Coming Soon",
    meta: {
      title: "Coming Soon",
      authRequired: true,
    },
    component: () => import("../views/pages/coming-soon.vue"),
  },
  {
    path: '/auth/404',
    name: '404',
    meta: {
      title: "Error 404",
    },
    component: () => import('../views/auth/errors/404')
  },
  {
    path: '/auth/500',
    name: '500',
    meta: {
      title: "Error 500", authRequired: true,
    },
    component: () => import('../views/auth/errors/500')
  },
  {
    path: '/auth/404-basic',
    name: '404-basic',
    meta: {
      title: "Error 404",
    },
    component: () => import('../views/auth/errors/404-basic')
  },
  {
    path: '/auth/404-cover',
    name: '404-cover',
    meta: {
      title: "Error 404"
    },
    component: () => import('../views/auth/errors/404-cover')
  },
  {
    path: '/auth/ofline',
    name: 'ofline',
    meta: {
      title: "Offline", authRequired: true,
    },
    component: () => import('../views/auth/errors/ofline')
  },
  {
    path: '/:catchAll(.*)',
    name: '404',
    meta: {
      title: "Error 404",
    },
    component: () => import('../views/auth/errors/404-basic')
  },
];